import React from 'react';
import memoize from 'lodash.memoize';
import styles from './TreatmentTypeList.module.css';

export interface TreatmentType {
  name: string;
  uri: string;
}

interface Props {
  treatmentTypes: TreatmentType[];
  onTreatmentTypeSelect: (treatmentTypeName: string) => void;
}

export class TreatmentTypeList extends React.PureComponent<Props> {
  private onTreatmentClickFactory = memoize(
    (treatmentType: TreatmentType) =>
      async (event: React.MouseEvent): Promise<void> => {
        if (!this.props.onTreatmentTypeSelect) {
          return;
        }

        event.preventDefault();

        await this.props.onTreatmentTypeSelect(treatmentType.name);
        window.location.href = treatmentType.uri;
      }
  );

  public render(): React.ReactNode {
    return (
      <ul className={styles.list}>
        {this.props.treatmentTypes.map((treatmentType) => (
          <li key={treatmentType.name} className={styles.treatmentType}>
            <a
              href={treatmentType.uri}
              onClick={this.onTreatmentClickFactory(treatmentType)}
            >
              {treatmentType.name}
            </a>
          </li>
        ))}
      </ul>
    );
  }
}
